var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { styled } from 'styled-components';
import { Pie as DefaultPie } from '@nivo/pie';
import { LinkButton } from '@hn-ui/buttons';
import theme from '../../../../../../../landing/components/core/themes/theme';
import { PIE_CHART_HEIGHT, PIE_CHART_WIDTH, PIE_HEIGHT, PIE_OFFSET, PIE_WIDTH, } from './constants';
import { mapSummaryToPiesData } from './utils';
import { ColorByStatus } from '../../../../constants/statuses';
import { GradeSummaryStatusTooltip } from '../Tooltips';
import { useSkillsSummaryAnalytics } from '../../hooks/useSkillsSummaryAnalytics';
import { SummaryStatusLegend } from '../../../StatusLegend';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-tc1xe2" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  width: ", "px;\n  height: ", "px;\n\n  & svg text[dominant-baseline='central'] {\n    dominant-baseline: auto !important;\n  }\n"], ["\n  display: flex;\n  justify-content: space-around;\n  width: ", "px;\n  height: ", "px;\n\n  & svg text[dominant-baseline='central'] {\n    dominant-baseline: auto !important;\n  }\n"])), PIE_CHART_WIDTH, PIE_CHART_HEIGHT);
var ScPieWrapper = styled.div.withConfig({ displayName: "ScPieWrapper", componentId: "sc-1e0k0yl" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var ScPieTitle = styled(LinkButton).withConfig({ displayName: "ScPieTitle", componentId: "sc-uztj8k" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  width: auto;\n"], ["\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  width: auto;\n"])));
var CustomSlices = function (_a) {
    var dataWithArc = _a.dataWithArc, arcGenerator = _a.arcGenerator, centerX = _a.centerX, centerY = _a.centerY, onClick = _a.onClick;
    var _b = useSkillsSummaryAnalytics(), onPartHover = _b.onPartHover, onTooltipHover = _b.onTooltipHover, onTooltipLinkClick = _b.onTooltipLinkClick;
    return (_jsx("g", __assign({ transform: "translate(" + centerX + "," + centerY + ")" }, { children: dataWithArc.map(function (el) {
            if (!el.value)
                return null;
            return (_jsx(GradeSummaryStatusTooltip, __assign({ status: el.data.id, domainName: el.data.domainName, gradeName: el.data.gradeName, students: el.data.students, onHover: onTooltipHover, onClick: function (evt) {
                    onClick(evt);
                    onTooltipLinkClick(el.data.id);
                } }, { children: _jsx("path", { d: arcGenerator(el.arc), fill: el.color, strokeWidth: '1', stroke: theme.colors.black100, onMouseEnter: function () { return onPartHover(el.data.id); } }, void 0) }), el.id));
        }) }), void 0));
};
var ScLegend = styled(SummaryStatusLegend).withConfig({ displayName: "ScLegend", componentId: "sc-rqb1d9" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-flex;\n  position: static;\n  margin: 0 auto;\n"], ["\n  display: inline-flex;\n  position: static;\n  margin: 0 auto;\n"])));
var Pie = function (_a) {
    var data = _a.data, onClick = _a.onClick, onDomainClick = _a.onDomainClick;
    var radians = useRef(0);
    return (_jsxs(ScPieWrapper, { children: [_jsx(ScPieTitle, __assign({ onClick: function () {
                    onDomainClick(data.name);
                } }, { children: data.name }), void 0), _jsx(DefaultPie, { width: PIE_WIDTH, height: PIE_HEIGHT, data: data.values, margin: {
                    top: PIE_OFFSET,
                    bottom: PIE_OFFSET,
                    right: PIE_OFFSET,
                    left: PIE_OFFSET,
                }, radialLabelsLinkOffset: 2, padAngle: 0, colors: function (props) { return ColorByStatus[props.id]; }, cornerRadius: 0, borderWidth: 1, borderColor: theme.colors.black100, enableSliceLabels: false, radialLabelsTextColor: theme.colors.black10, radialLabelsLinkColor: theme.colors.black80, radialLabelsLinkHorizontalLength: 14, radialLabelsLinkDiagonalLength: 11, radialLabelsSkipAngle: 2, 
                // doesn't allow to return an element. It's fixed by the new version
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                radialLabel: function (_a) {
                    var _b = _a.value, value = _b === void 0 ? 0 : _b, angle = _a.arc.angle;
                    if (radians.current >= Math.PI * 2)
                        radians.current = 0;
                    var targetDx = value.toString().length === 1 ? 18 : 20;
                    var dx = (radians.current + angle / 2 < Math.PI ? -targetDx : targetDx - 4) + "px";
                    radians.current += angle;
                    return (_jsx("tspan", __assign({ dx: dx, dy: '-4px' }, { children: value }), void 0));
                }, layers: [
                    'radialLabels',
                    'legends',
                    function (props) { return _jsx(CustomSlices, __assign({}, props, { onClick: onClick }), void 0); },
                ], theme: {
                    fontFamily: 'Noto Sans',
                    legends: { text: { fontWeight: 'bold' } },
                }, isInteractive: true, fit: false, tooltip: function () { return null; } }, data.name)] }, void 0));
};
var PieChart = function (_a) {
    var data = _a.data, onClick = _a.onClick, onDomainClick = _a.onDomainClick, rest = __rest(_a, ["data", "onClick", "onDomainClick"]);
    var piesData = useMemo(function () { return mapSummaryToPiesData(data); }, [data]);
    var onPieChartHover = useSkillsSummaryAnalytics().onPieChartHover;
    return (_jsxs(_Fragment, { children: [_jsx(Container, __assign({}, rest, { onMouseEnter: onPieChartHover }, { children: piesData.map(function (pie) { return (_jsx(Pie, { data: pie, onClick: onClick, onDomainClick: onDomainClick }, pie.name)); }) }), void 0), _jsx(ScLegend, {}, void 0)] }, void 0));
};
export { PieChart };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
